import { IndustryConfig } from '../../../types'

export const technologySoftwareConsultingConfig: IndustryConfig = {
  id: 'technology-software-consulting',
  name: 'Technology & Software Consulting',
  icon: '💻',
  description: 'Technology consultants and software development firms focused on specialization and pricing optimization',
  
  businessTypes: [
    {
      id: 'software-development',
      name: 'Software Development Agency',
      description: 'Custom software development and application services'
    },
    {
      id: 'it-consulting',
      name: 'IT Consulting Firm',
      description: 'Technology strategy, implementation, and system integration services'
    },
    {
      id: 'saas-development',
      name: 'SaaS Development',
      description: 'Software-as-a-Service product development and maintenance'
    },
    {
      id: 'technology-consulting',
      name: 'Technology Consulting',
      description: 'Specialized technology consulting in areas like cloud, AI, or cybersecurity'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'project-development',
      name: 'Project Development',
      description: 'Revenue from fixed-price software development projects',
      intelligenceValue: "We'll monitor project pricing trends, scope creep patterns, and market demand for different technologies to help you optimize project pricing and technology focus areas."
    },
    {
      id: 'hourly-consulting',
      name: 'Hourly Consulting',
      description: 'Time-based consulting and development services',
      intelligenceValue: "We'll track hourly rate benchmarks by skill level and technology, demand patterns, and competitor positioning to help you optimize your rate structure and specialization strategy."
    },
    {
      id: 'retainer-contracts',
      name: 'Retainer Contracts',
      description: 'Ongoing technology support and maintenance contracts',
      intelligenceValue: "We'll monitor client retention trends, retainer pricing models, and service delivery optimization to help you build more predictable recurring revenue streams."
    },
    {
      id: 'product-licensing',
      name: 'Product Licensing',
      description: 'Revenue from software products, SaaS offerings, and intellectual property',
      intelligenceValue: "We'll track SaaS pricing trends, market adoption patterns, and competitive product positioning to help you optimize your product strategy and pricing models."
    }
  ],
  
  supplierCategories: [
    {
      id: 'development-tools',
      name: 'Development Tools & Software',
      suppliers: ['IDE licenses', 'Cloud platforms (AWS, Azure, GCP)', 'Development frameworks', 'Testing tools', 'Project management software'],
      spendRanges: ['Under $2K', '$2K-$10K', '$10K-$50K', 'Over $50K']
    },
    {
      id: 'infrastructure-hosting',
      name: 'Infrastructure & Hosting',
      suppliers: ['Cloud hosting providers', 'CDN services', 'Database services', 'Security services', 'Monitoring tools'],
      spendRanges: ['Under $1K', '$1K-$8K', '$8K-$40K', 'Over $40K']
    },
    {
      id: 'talent-resources',
      name: 'Talent & Resources',
      suppliers: ['Freelance developers', 'Recruiting services', 'Training platforms', 'Contractor agencies', 'Skills assessment tools'],
      spendRanges: ['Under $5K', '$5K-$25K', '$25K-$100K', 'Over $100K']
    },
    {
      id: 'business-operations',
      name: 'Business Operations',
      suppliers: ['Office space/coworking', 'Legal services', 'Accounting software', 'Marketing tools', 'Insurance providers'],
      spendRanges: ['Under $3K', '$3K-$12K', '$12K-$40K', 'Over $40K']
    }
  ],
  
  competitiveFactors: [
    'Technical expertise depth',
    'Technology specialization',
    'Project delivery track record',
    'Pricing competitiveness',
    'Development speed',
    'Code quality standards',
    'Client communication',
    'Industry experience',
    'Team scalability',
    'Innovation capabilities'
  ]
}